import { render, staticRenderFns } from "./AddEditAdminDialog.vue?vue&type=template&id=2da9a50e&scoped=true&"
import script from "./AddEditAdminDialog.vue?vue&type=script&lang=js&"
export * from "./AddEditAdminDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddEditAdminDialog.vue?vue&type=style&index=0&id=2da9a50e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da9a50e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2da9a50e')) {
      api.createRecord('2da9a50e', component.options)
    } else {
      api.reload('2da9a50e', component.options)
    }
    module.hot.accept("./AddEditAdminDialog.vue?vue&type=template&id=2da9a50e&scoped=true&", function () {
      api.rerender('2da9a50e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin-access/AddEditAdminDialog.vue"
export default component.exports